import styled from 'styled-components'

export const ContainerMaternalInfant = styled.div`
  position: relative;
  flex: 1;
  height: 100%;
  padding: 40px 10px 10px;

  overflow: hidden;
  flex-direction: column;
  display: flex;
  gap: 1rem;
`
